(ns io.daskul.webapp.display-template
  "Pure label-template / display-vector logic (#792) — the cljs mirror of the
   framework's io.daskul.framework.label-template. No React/Mantine imports so
   it runs under the :node-test build.

   Parts (post-normalization):
   - keyword          field get
   - vector           nested get-in
   - string           literal separator, interpolated unconditionally
   - map              {:get part :fmt token :prefix literal} — :prefix only
                      renders when the value is present

   :fmt tokens (values arrive as JSON strings client-side):
   - :dow-mmm-d  \"2026-08-12\"        → \"Wed, Aug 12\"
   - :h12        \"10:00\" / \"10:00:00\" → \"10:00 AM\"

   Unknown tokens and unparseable values fall back to (str value)."
  (:require [clojure.string :as str]))

(defn- field-ref?
  "True if string looks like a keyword field reference (e.g., \"invoice-number\").
   False for literal separators (e.g., \" — \", \" \", \"/\")."
  [s]
  (re-matches #"[a-z][a-z0-9-]*" s))

(defn- normalize-get
  "Normalize a map part's :get after JSON round-trip: string → keyword,
   array → keyword path."
  [g]
  (if (vector? g) (mapv keyword g) (keyword g)))

(defn normalize-part
  "Normalize a display vector part after JSON round-trip.
   Keywords and field-ref strings → keyword, literal strings stay,
   vectors → keywordize, maps → keywordize :get / :fmt."
  [part]
  (cond
    (keyword? part) part
    (string? part) (if (field-ref? part) (keyword part) part)
    (vector? part) (mapv keyword part)
    (map? part) (cond-> (update part :get normalize-get)
                  (:fmt part) (update :fmt keyword))
    :else part))

(def ^:private day-names ["Sun" "Mon" "Tue" "Wed" "Thu" "Fri" "Sat"])
(def ^:private month-names ["Jan" "Feb" "Mar" "Apr" "May" "Jun"
                            "Jul" "Aug" "Sep" "Oct" "Nov" "Dec"])

(defn- parse-int [s]
  (let [n (js/parseInt s 10)]
    (when-not (js/isNaN n) n)))

(defn format-date-dow-mmm-d
  "\"2026-08-12\" → \"Wed, Aug 12\". Unparseable → input unchanged."
  [s]
  (or (when (string? s)
        (let [[y m d] (map parse-int (str/split s #"-"))]
          (when (and y m d (<= 1 m 12))
            ;; Local-midnight Date — never UTC parse, which shifts the day.
            (let [dt (js/Date. y (dec m) d)]
              (str (day-names (.getDay dt)) ", " (month-names (dec m)) " " d)))))
      s))

(defn format-time-h12
  "\"10:00\" / \"10:00:00\" / \"13:30\" → \"10:00 AM\" / \"1:30 PM\".
   Unparseable → input unchanged."
  [s]
  (or (when (string? s)
        (let [[h m] (str/split s #":")
              h (parse-int h)]
          (when (and h (<= 0 h 23) m)
            (str (let [r (mod h 12)] (if (zero? r) 12 r))
                 ":" m " " (if (< h 12) "AM" "PM")))))
      s))

(defn format-value
  "Format v per fmt token; unknown token or unparseable value → (str v)."
  [fmt v]
  (case fmt
    :dow-mmm-d (format-date-dow-mmm-d v)
    :h12 (format-time-h12 v)
    (str v)))

(defn- resolve-part [record part]
  (cond
    (keyword? part) (get record part)
    (vector? part) (get-in record part)
    :else part))

(defn- render-part [record part]
  (if (map? part)
    (let [{part-get :get fmt :fmt prefix :prefix} part
          v (resolve-part record part-get)
          s (when (some? v) (if fmt (format-value fmt v) (str v)))]
      (if (str/blank? s) "" (str prefix s)))
    (let [v (resolve-part record part)]
      (if (some? v) (str v) ""))))

(defn render
  "Render a display vector against a record.
   Returns nil if record is nil or the result is blank."
  [record template]
  (when (and record (seq template))
    (let [result (->> template
                      (map (partial render-part record))
                      (str/join))]
      (when-not (str/blank? result)
        result))))
